module.exports = __webpack_public_path__ + "img/sub.f496dbf5.svg";